"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useDebouncer = require("./useDebouncer.cjs");
function useDebouncedCallback(fn, options) {
  const debouncedFn = useDebouncer.useDebouncer(fn, options).maybeExecute;
  return react.useCallback((...args) => debouncedFn(...args), [debouncedFn]);
}
exports.useDebouncedCallback = useDebouncedCallback;
//# sourceMappingURL=useDebouncedCallback.cjs.map
